import React, { useReducer, useContext } from "react";
import { editCoachPoolReducer as reducer } from "../reducers/editCoachPoolReducer";
import { editCoachPoolActions as actions } from "../actions/editCoachPoolActions";

const initialValue = {
  coaches: null,
  coachPool: {
    attributes: {
      name: "",
      default: false,
    },
  },
  coachSelected: [],
  coachPoolNameError: "",
  allRecordSelected: false,
  formCanged: false,
  backUrl: null,
};

const editCoachPoolContext = React.createContext();

const EditCoachPoolContext = ({
  coachPool,
  coachSelected,
  backUrl,
  children,
}) => {
  initialValue.coachPool = coachPool;
  initialValue.coachSelected = coachSelected;
  initialValue.backUrl = backUrl;

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <editCoachPoolContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </editCoachPoolContext.Provider>
  );
};

export const useEditCoachPoolContext = () =>
  React.useContext(editCoachPoolContext);
export default EditCoachPoolContext;
